import React, { memo } from 'react';
import styled from 'styled-components';
import { continents } from '../../../../common/translation/translate';
import { reduxConnect } from '../../../../common';
import { selectContinentAction } from '../../../../common/actions/sitemapAction';
import { StatesContinentsListItemLink } from './statesContinentsListItemLink';
import { withScreenSize } from '../../../common/utilities/withScreenSize.jsx';

interface PageFooterContinentListProps {
    selectContinentAction(continentName: string, continentRoute: string): void;
    isDesktop: boolean;
}

const mapStoreStateToProps = (storeState: any) => {
    return {};
};

const mapDispatchToProps  = {
    selectContinentAction
};

export const PageFooterContinentList = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(withScreenSize(memo(({
    selectContinentAction,
    isDesktop
}: PageFooterContinentListProps) => {

    if (!isDesktop) {
        return null;
    }

    return (
        <ContinentsListContainer key='continents_list_footer'>
            {
                continents?.map((continent) => {
                    return(
                        <ContinentsListItem key={`${continent?.path}_${continent?.name}`}>
                            <StatesContinentsListItemLink
                                onClick={() => selectContinentAction(
                                    continent?.name,
                                    continent?.path
                                )}
                                href={continent?.path}>
                                {continent?.name}
                            </StatesContinentsListItemLink>
                        </ContinentsListItem>
                    );
                })
            }
        </ContinentsListContainer>
    );
})));

const ContinentsListContainer = styled.ul`
    display: flex;
    flex-direction: row;
    width: 90%;
    height: auto;
    margin-top: 23px;
    padding: 0;
    justify-content: space-between;
    list-style-type: none;
    text-align: center;
    column-count: 6;
`;

const ContinentsListItem = styled.li`
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;